import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '招考大帮忙';
const baseUrl = '2022GKDBM';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'major',
      name: `${baseUrl}-major`,
      component: () => import('./pages/Major.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'interview',
      name: `${baseUrl}-interview`,
      component: () => import('./pages/Interview.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'brand',
      name: `${baseUrl}-brand`,
      component: () => import('./pages/Brand.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'message',
      name: `${baseUrl}-message`,
      component: () => import('./pages/Message.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
